import groq from 'groq';

import {
  ASSET,
  BAR_CHART,
  RICH_TEXT,
  STUDY_MODAL,
  VIDEO_CARD,
} from '../common';

export const CHART_BLOCK_FIELDS = groq`
  _type,
  _key,
  title,
  subtitle,
  description[]{
    ${RICH_TEXT}
  },
  kickerLabel,
  videoCard {
    ${VIDEO_CARD}
  },
  modal->{
    ${STUDY_MODAL}
  },
  "journalLogo": studyRef->publishedDetails.journalLogo { ${ASSET} },
  chart,
  "chartImage": chartImage.lightMode { ${ASSET} },
  barChart {
    ${BAR_CHART}
  }
`;

export const CHART_BLOCK = groq`
  (_type == 'timeline_chartBlock') => @-> {
    ${CHART_BLOCK_FIELDS}
  }
`;
